import type { UseQueryResult } from '@tanstack/react-query';

/** Who can view a published Flora page. */
enum FloraPageVisibility {
  Private = 'PRIVATE',
  Organization = 'ORGANIZATION',
}

/** A Flora-published static HTML page hosted at an in-app URL. */
type FloraPage = {
  id: string;
  title: string;
  visibility: FloraPageVisibility;
  organization_id: string;
  user_id: string | null;
  html_size_bytes: number | null;
  metadata_created_at: string;
  metadata_updated_at: string;
};

/** Editable fields for a Flora page (owner only). */
type FloraPageWritePayload = {
  title?: string;
  visibility?: FloraPageVisibility;
};

/** Short-lived signed URL for loading a page's HTML into the viewer iframe. */
type FloraPageViewUrl = {
  url: string;
  expires_in: number;
};

type UseFloraPagesResult = {
  floraPages: FloraPage[];
  query: UseQueryResult<FloraPage[]>;
};

type UseFloraPageResult = {
  page: FloraPage | undefined;
  query: UseQueryResult<FloraPage>;
};

type UseFloraPageViewUrlResult = {
  viewUrl: FloraPageViewUrl | undefined;
  query: UseQueryResult<FloraPageViewUrl>;
};

export { FloraPageVisibility };
export type {
  FloraPage,
  FloraPageViewUrl,
  FloraPageWritePayload,
  UseFloraPageResult,
  UseFloraPagesResult,
  UseFloraPageViewUrlResult,
};
